import { makeStyles, css } from '@conexasaude/hero-web'

const useStyles = makeStyles({
  root: () => css`
    display: flex;
    align-items: center;
    height: 38px;
  `,

  input: theme => css`
    width: 100%;
    height: 38px;
    padding-left: 16px;
    padding-right: 16px;
    border: 1px solid ${theme.colors.primary[500]};
    border-top-left-radius: ${theme.borderRadius.sm};
    border-bottom-left-radius: ${theme.borderRadius.sm};
    outline: none;
    box-sizing: border-box;
  `,

  button: theme => css`
    background-color: ${theme.colors.primary[500]};
    margin: 0;
    min-width: 48px;
    min-height: 38px;
    border: none;
    border-top-right-radius: ${theme.borderRadius.sm};
    border-bottom-right-radius: ${theme.borderRadius.sm};
    cursor: pointer;
    box-sizing: border-box;
  `,
})

export { useStyles }
